export const SETTLEMENT_REPORT_PATH = '/manage/reports/client-settlements';

export function getSettlementReturnLocation(location) {
  const target = location && location.state && location.state.settlementReturn;
  return target && target.pathname === SETTLEMENT_REPORT_PATH ? target : null;
}

export function readSettlementView(location, principalKey, schoolYearStartYear) {
  const view = location.state && location.state.settlementView;
  return view && view.principalKey === principalKey && view.schoolYearStartYear === schoolYearStartYear ? view : null;
}
